export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9681.20cfba27.jpg";